import { Card, CardContent } from "@/components/ui/card";

export default function KPICard({ icon: Icon, label, value, subtext, onClick, testId }) {
  return (
    <Card
      data-testid={testId}
      className="cursor-pointer border border-[#eadfcd] bg-white/95 shadow-[0_16px_45px_rgba(94,64,18,0.08)] transition hover:-translate-y-0.5 hover:shadow-[0_20px_55px_rgba(94,64,18,0.14)] dark:border-[#4d3d16] dark:bg-[#0d0c09]/95 dark:shadow-[0_16px_45px_rgba(0,0,0,0.36)] dark:hover:shadow-[0_20px_55px_rgba(0,0,0,0.5)]"
      onClick={onClick}
    >
      <CardContent className="p-6">
        <div className="flex items-start gap-5">
          <div className="grid h-14 w-14 shrink-0 place-items-center rounded-full bg-gradient-to-br from-[#f2c764] to-[#b77900] text-white shadow-[0_12px_28px_rgba(185,119,0,0.24)]">
            <Icon className="h-7 w-7" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium text-slate-950 dark:text-[#d5c8ae]">{label}</p>
            <p className="mt-2 text-3xl font-bold leading-none text-slate-950 dark:text-[#f8efe0]">
              {value}
            </p>
            {subtext && <p className="mt-3 text-sm text-slate-500 dark:text-[#9f947f]">{subtext}</p>}
          </div>
        </div>
        <div className="mt-6 h-1 overflow-hidden rounded-full bg-[#f4ead8] dark:bg-[#2a2110]">
          <div className="h-full w-1/3 rounded-full bg-gradient-to-r from-[#b77900] to-[#f5cf75]" />
        </div>
      </CardContent>
    </Card>
  );
}
